import { IconProps } from "../../../types/style";

const PlusMiniSvg = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 10 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.095 0.5H2.905C1.085 0.5 0 1.585 0 3.405V7.59C0 9.415 1.085 10.5 2.905 10.5H7.09C8.91 10.5 9.995 9.415 9.995 7.595V3.405C10 1.585 8.915 0.5 7.095 0.5ZM7 5.875H5.375V7.5C5.375 7.705 5.205 7.875 5 7.875C4.795 7.875 4.625 7.705 4.625 7.5V5.875H3C2.795 5.875 2.625 5.705 2.625 5.5C2.625 5.295 2.795 5.125 3 5.125H4.625V3.5C4.625 3.295 4.795 3.125 5 3.125C5.205 3.125 5.375 3.295 5.375 3.5V5.125H7C7.205 5.125 7.375 5.295 7.375 5.5C7.375 5.705 7.205 5.875 7 5.875Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default PlusMiniSvg;
